import { ActivatedRoute, Router } from '@angular/router';
import { LocalStorageService } from './../../core/services/local-storage.service';
import { Component } from '@angular/core';
import { environment } from './../../../../src/environment/environment';
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css'],
})
export class FooterComponent {
  constructor(private localStorageService: LocalStorageService, private router: Router) {}
  env = environment;
  typeintervenant: string | null | number =
    this.localStorageService.getData('typeintervenant');
  connectedUser: string | null | number =
    this.localStorageService.getData('userConnected');

    redirect(){
      window.open('https://wegestu.com/a-propos/', '_blank','noopener,noreferrer');
    }

    redirectToContact() {
      this.router.navigate(['/contacter-nous']);
    }
  }